import Swiper, { Autoplay, Lazy, Navigation, Pagination, Scrollbar } from 'swiper';
Swiper.use([Autoplay, Lazy, Navigation, Pagination, Scrollbar]);

// ===============================================================
// BUSCA O CARRINHO ATIVO
// ===============================================================
export async function getCart() {
  try {
    const response = await fetch('/carrinho');
    const cart = await response.json();
    return cart;
  } catch (error) {
    console.error('Erro ao buscar os dados do carrinho');
    console.error(error);
  }
}

// ===============================================================
// SERIALIZE ARRAY
// ===============================================================
export function serializeArray(form) {

  const formData = new FormData(form);
  const data = {};

  for (const [name, value] of formData) {
    data[name] = value
  }

  const formBody = [];

  for (const key in data) {
    const encodeKey = encodeURIComponent(key)
    const encodeValue = encodeURIComponent(data[key])
    formBody.push(`${encodeKey}=${encodeValue}`)
  }

  return formBody = formBody.join('&')
  
}

// ===============================================================
// URL ENCODE FORM DATA
// ===============================================================
export function urlEncodeFormData(formData) {
  let string = '';

  function encode(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
  }

  for (const pair of formData.entries()) {
    if (typeof pair[1] == 'string') {
      string += (string ? '&' : '') + encode(pair[0]) + '=' + encode(pair[1]);
    }
  }
  return string;
}

// ===============================================================
// PREÇO POR AJAX
// ===============================================================
export function getPriceProd() {
  const attr = 'data-update-price';
  
  const priceEls = document.querySelectorAll(`[${attr}]`);
  if (priceEls.length > 0) {
    priceEls.forEach(priceEl => {
      let prodId = priceEl.getAttribute(attr);
      let url = '/produto/preco/' + prodId;

      if (prodId != '' && prodId != null) {
        $.ajax({
          url: url,
          type: 'GET',
        })
        .done((resp) => {
          priceEl.innerHTML = resp;
        })
        .fail((resp) => {
          console.error('price error', resp);
        });
      }
    });
  }
}

// ===============================================================
// DEBOUNCE
// ===============================================================
export function debounce(func, wait, immediate) {
  var timeout;
  immediate || (immediate = true);

  return function () {
    var context = this,
      args = arguments;

    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

// ===============================================================
// THROTTLE
// ===============================================================
export function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

// ===============================================================
// FORMAT MONEY
// ===============================================================
export function formatMoney(value) {
  // FORMATA UM VALOR
  return (
    'R$ ' +
    value
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+\,)/g, '$1.')
  );
}

// ===============================================================
// PRODUCTS CAROUSEL
// ===============================================================
export function setProducts() {
  const swiperEls = document.querySelectorAll('[data-products]');
  if (swiperEls.length > 0) 
    swiperEls.forEach(swiperEl => {
      new Swiper(swiperEl, {
        watchOverflow: true,
        speed: 700,
        watchSlidesProgress: true,
        loop: false,
        simulateTouch: true,
        spaceBetween: 8,
        slidesPerView: 1.5,
        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 3,
          },
          992: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
          1200: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
        },
        navigation: {
          prevEl: swiperEl.parentElement.parentElement.querySelector('.-prev'),
          nextEl: swiperEl.parentElement.parentElement.querySelector('.-next'),
          disabledClass: '-disabled',
        },
        pagination: {
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: '-active',
          el: swiperEl.parentElement.parentElement.querySelector('.pagination'),
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          },
        },
        // swiper lazy load
        preloadImages: false,
        watchVisibility: true,
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true
        }     
      });
    });
}

// ===============================================================
// PRODUCT PURCHASE SCRIPT
// ===============================================================
export function initPurchase() {
  const products = document.querySelectorAll('[data-product-purchase]');
  if (products.length > 0) {
    var hasScript = false;
    products.forEach(product => {
      let observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          if (!hasScript) {
            hasScript = true;
            
            let newScript = document.createElement('script');
            newScript.src = window.productPurchaseJs;
            document.body.appendChild(newScript);
            
            console.log('productPurchase.js');
          }
          observer.disconnect();
        }
      }, { threshold: 0.1 });
      observer.observe(product.closest('[data-product-box]'));
    });
  }
}

// ===============================================================
// FOOTER DROPDOWNS
// ===============================================================
export function setFooterDropdowns() {
  const clickEls = document.querySelectorAll('[data-footer-click]');
  const dropdownEls = document.querySelectorAll('[data-footer-dropdown]');

  if (clickEls.length > 0 && dropdownEls.length > 0)
    clickEls.forEach((clickEl, i) => {
      clickEl.addEventListener('click', (e) => {

        if (document.body.scrollWidth <= 991) {
          e.preventDefault();

          clickEls[i].classList.toggle('-active');
          dropdownEls[i].classList.toggle('-active');
        }
      });
    });
}

// ===============================================================
// VERIFICA ACESSO DO CLIENTE
// ===============================================================
export async function getClient() {
  try {
    let response = await fetch('/conta/cliente', {
      headers: { 
        accept: 'application/json'
      }
    });
    let client = await response.json();
    let access = Object.keys(client).length > 0;
    
    if (access)
      return client;
    if (!access)
      return false;
    
  } catch (error) { console.error(`getClient error`, error) }
}

// ===============================================================
// TOP BAR CAROUSEL
// ===============================================================
export function topBar() {
  const swiperEl = document.querySelector('[data-top]');
  if (swiperEl)
    new Swiper(swiperEl, {
      direction: 'vertical',
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: true,
      loop: true,
      speed: 600,
      autoplay: { delay: 4000 }
    });
}
